import css from 'styled-jsx/css';

export default css`
  .featured-wrapper {
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .features-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    max-width: 760px;
    justify-items: center;
    align-content: center;
    padding: 30px 0;
  }
  .features-wrapper > *:last-child {
    margin-bottom: 30px;
  }
  .active-link {
    color: #a41c1c;
  }
  @media (max-width: 767px) {
    .features-wrapper {
      padding: 0;
    }
  }
`;
